export const ASOCOINS_EVENT_RULES = [
  { value: 'EVENT_CONVENTION', label: 'Convención Nacional · 5,000 por boleto' },
  { value: 'REGIONAL_MEETING', label: 'Encuentro regional · 1,000 por boleto' },
  { value: 'NETWORKING', label: 'Networking · 1,000 por boleto' },
  { value: 'WORKSHOP', label: 'Taller · 1,000 por boleto' },
  { value: 'WEBINAR', label: 'Webinar · 300 por orden' },
];
